export default __webpack_public_path__ + "static/media/komal.da05bcf7.jpg";